module.exports = __webpack_public_path__ + "static/media/ils_loan_intro_card.a736f113.svg";